import api from './api'

const paymentService = {
  /**
   * Create a Stripe checkout session for premium upgrade
   * Returns a URL to redirect the user to Stripe's checkout page
   */
  createCheckout: async () => {
    const response = await api.post('/payments/create-checkout')
    return response.data
  },

  /**
   * Get payment history for current account
   */
  getPaymentHistory: async () => {
    const response = await api.get('/payments/history')
    return response.data
  },

  /**
   * Verify premium status (checks if premium has expired)
   */
  verifyPremium: async () => {
    const response = await api.post('/payments/verify-premium')
    return response.data
  },
}

export default paymentService
